import { Component, defineAsyncComponent } from 'vue';

import { FieldType } from '@/modules/dynamic-form/models/FieldType.model';

// PRODUCT-26110 Task 12b (COMPONENT_ASYNC): a raw `() => Promise<any>` factory handed
// straight to `<component :is="...">` relies on @vue/compat's `convertLegacyComponent`
// to wrap it into a real async component; with that flag disabled, Vue 3 core would
// instead treat it as a plain functional-component render function (called
// synchronously, expecting a vnode back, not a Promise). `defineAsyncComponent(...)`
// makes every entry a real Component up front, independent of the compat flag.
export type ComponentResolver = Component;

export const defaultComponents: Partial<Record<FieldType, ComponentResolver>> = {
    String: defineAsyncComponent(() => import('@/modules/dynamic-form/components/control-inputs/text-input-control/TextInputControl.vue')),
    Boolean: defineAsyncComponent(() => import('@/modules/dynamic-form/components/control-inputs/bool-input-control/BoolInputControl.vue')),
    StringBoolean: defineAsyncComponent(() => import('@/modules/dynamic-form/components/control-inputs/string-boolean-input-control/StringBooleanInputControl.vue')),
    Int: defineAsyncComponent(() => import('@/modules/dynamic-form/components/control-inputs/int-input-control/IntInputControl.vue')),
    Float: defineAsyncComponent(() => import('@/modules/dynamic-form/components/control-inputs/float-input-control/FloatInputControl.vue')),
    Date: defineAsyncComponent(() => import('@/modules/dynamic-form/components/control-inputs/date-input-control/DateInputControl.vue')),
    Enum: defineAsyncComponent(() => import('@/modules/dynamic-form/components/control-inputs/enum-input-control/EnumInputControl.vue')),
    Address: defineAsyncComponent(() => import('@/modules/dynamic-form/components/control-inputs/address-input-control/AddressInputControl.vue')),
    List: defineAsyncComponent(() => import('@/modules/dynamic-form/components/control-inputs/list-input-control/ListInputControl.vue')),
};

export function getControlComponents(
    key: FieldType, customMap?: Record<string, ComponentResolver>,
): ComponentResolver | null {
    if (customMap?.[key]) {
        return customMap[key] || null;
    }
    return defaultComponents[key] || null;
}
